module.exports = __webpack_public_path__ + "static/media/trovalogo-white.3e98bab1.png";